import { MAIN_DEX } from "./marketIdentity"
import type { HLDexName } from "./types"

export const hyperliquidQueryKeys = {
  account: (address?: `0x${string}`, dex: HLDexName = MAIN_DEX) =>
    ["hyperliquid", "account", address ?? "anonymous", dex] as const,
  tradingBalancePrefix: (address?: `0x${string}`) =>
    ["hyperliquid", "trading-balance", address ?? "anonymous"] as const,
  tradingBalance: (address?: `0x${string}`, dex: HLDexName = MAIN_DEX) =>
    ["hyperliquid", "trading-balance", address ?? "anonymous", dex] as const,
  userAbstraction: (address?: `0x${string}`) =>
    ["hyperliquid", "user-abstraction", address ?? "anonymous"] as const,
  portfolio: (address?: `0x${string}`) =>
    ["hyperliquid", "portfolio", address ?? "anonymous"] as const,
  markets: () => ["hyperliquid", "markets"] as const,
  mids: () => ["hyperliquid", "mids"] as const,
  assetMeta: (coin: string) => ["hyperliquid", "asset-meta", coin] as const,
  assetContext: (coin: string) =>
    ["hyperliquid", "asset-context", coin] as const,
  activeAsset: (address?: `0x${string}`, coin?: string) =>
    [
      "hyperliquid",
      "active-asset",
      address ?? "anonymous",
      coin ?? "",
    ] as const,
  activeAssetPrefix: (address?: `0x${string}`) =>
    ["hyperliquid", "active-asset", address ?? "anonymous"] as const,
  candles: (
    coin: string,
    interval: "1m" | "3m" | "5m" | "15m" | "1h" | "4h" | "8h" | "1d" | "1w",
    lookbackMs: number
  ) => ["hyperliquid", "candles", coin, interval, lookbackMs] as const,
  sparklineCandles: (coin: string, lookbackMs: number) =>
    ["hyperliquid", "sparkline-candles", coin, "1h", lookbackMs] as const,
  openOrders: (address?: `0x${string}`, dex: HLDexName = MAIN_DEX) =>
    ["hyperliquid", "open-orders", address ?? "anonymous", dex] as const,
  fills: (address?: `0x${string}`) =>
    ["hyperliquid", "fills", address ?? "anonymous"] as const,
  fillsPrefix: (address?: `0x${string}`) =>
    ["hyperliquid", "fills", address ?? "anonymous"] as const,
}
